/**
 * Bunny AI Gateway
 * Security-first AI gateway. One API. Every model. Total protection. All `/v1/_*` endpoints are transparently proxied to the underlying AI Gateway runtime. Use a valid API key in the `Authorization` header.
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { HttpClient, HttpContext, HttpEvent, HttpHeaders, HttpParameterCodec, HttpParams, HttpResponse } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';

import { Observable } from 'rxjs';

import { Configuration } from '../configuration';
import { CustomHttpParameterCodec } from '../encoder';
// @ts-ignore
import { AnalyticsEnvelope } from '../model/analytics-envelope';
// @ts-ignore
// @ts-ignore
import { BASE_PATH } from '../variables';

export interface AnalyticsBudgetApiAiGatewayAnalyticsBudgetGetRequestParams {
  range?: string;
  /** ISO 8601 window start; with dateTo, overrides range (arbitrary range). */
  dateFrom?: string | null;
  /** ISO 8601 window end; with dateFrom, overrides range (arbitrary range). */
  dateTo?: string | null;
  userId?: string | null;
  keyHash?: string | null;
}

export interface AnalyticsBudgetShortAliasAnalyticsBudgetGetRequestParams {
  range?: string;
  /** ISO 8601 window start; with dateTo, overrides range (arbitrary range). */
  dateFrom?: string | null;
  /** ISO 8601 window end; with dateFrom, overrides range (arbitrary range). */
  dateTo?: string | null;
  userId?: string | null;
  keyHash?: string | null;
}

export interface AnalyticsEndpointsApiAiGatewayAnalyticsEndpointsGetRequestParams {
  range?: string;
  /** ISO 8601 window start; with dateTo, overrides range (arbitrary range). */
  dateFrom?: string | null;
  /** ISO 8601 window end; with dateFrom, overrides range (arbitrary range). */
  dateTo?: string | null;
  limit?: number;
  userId?: string | null;
}

export interface AnalyticsEndpointsShortAliasAnalyticsEndpointsGetRequestParams {
  range?: string;
  /** ISO 8601 window start; with dateTo, overrides range (arbitrary range). */
  dateFrom?: string | null;
  /** ISO 8601 window end; with dateFrom, overrides range (arbitrary range). */
  dateTo?: string | null;
  limit?: number;
  userId?: string | null;
}

export interface AnalyticsErrorsApiAiGatewayAnalyticsErrorsGetRequestParams {
  range?: string;
  /** ISO 8601 window start; with dateTo, overrides range (arbitrary range). */
  dateFrom?: string | null;
  /** ISO 8601 window end; with dateFrom, overrides range (arbitrary range). */
  dateTo?: string | null;
  groupBy?: string;
  userId?: string | null;
  keyHash?: string | null;
}

export interface AnalyticsErrorsShortAliasAnalyticsErrorsGetRequestParams {
  range?: string;
  /** ISO 8601 window start; with dateTo, overrides range (arbitrary range). */
  dateFrom?: string | null;
  /** ISO 8601 window end; with dateFrom, overrides range (arbitrary range). */
  dateTo?: string | null;
  groupBy?: string;
  userId?: string | null;
  keyHash?: string | null;
}

export interface AnalyticsKeysApiAiGatewayAnalyticsKeysGetRequestParams {
  page?: number;
  perPage?: number;
  range?: string;
  /** ISO 8601 window start; with dateTo, overrides range (arbitrary range). */
  dateFrom?: string | null;
  /** ISO 8601 window end; with dateFrom, overrides range (arbitrary range). */
  dateTo?: string | null;
  userId?: string | null;
}

export interface AnalyticsKeysShortAliasAnalyticsKeysGetRequestParams {
  page?: number;
  perPage?: number;
  range?: string;
  /** ISO 8601 window start; with dateTo, overrides range (arbitrary range). */
  dateFrom?: string | null;
  /** ISO 8601 window end; with dateFrom, overrides range (arbitrary range). */
  dateTo?: string | null;
  userId?: string | null;
}

export interface AnalyticsModelsApiAiGatewayAnalyticsModelsGetRequestParams {
  range?: string;
  /** ISO 8601 window start; with dateTo, overrides range (arbitrary range). */
  dateFrom?: string | null;
  /** ISO 8601 window end; with dateFrom, overrides range (arbitrary range). */
  dateTo?: string | null;
  sort?: string;
  limit?: number;
  userId?: string | null;
  keyHash?: string | null;
}

export interface AnalyticsModelsShortAliasAnalyticsModelsGetRequestParams {
  range?: string;
  /** ISO 8601 window start; with dateTo, overrides range (arbitrary range). */
  dateFrom?: string | null;
  /** ISO 8601 window end; with dateFrom, overrides range (arbitrary range). */
  dateTo?: string | null;
  sort?: string;
  limit?: number;
  userId?: string | null;
  keyHash?: string | null;
}

export interface AnalyticsRegionsApiAiGatewayAnalyticsRegionsGetRequestParams {
  range?: string;
  /** ISO 8601 window start; with dateTo, overrides range (arbitrary range). */
  dateFrom?: string | null;
  /** ISO 8601 window end; with dateFrom, overrides range (arbitrary range). */
  dateTo?: string | null;
  userId?: string | null;
}

export interface AnalyticsRegionsShortAliasAnalyticsRegionsGetRequestParams {
  range?: string;
  /** ISO 8601 window start; with dateTo, overrides range (arbitrary range). */
  dateFrom?: string | null;
  /** ISO 8601 window end; with dateFrom, overrides range (arbitrary range). */
  dateTo?: string | null;
  userId?: string | null;
}

export interface AnalyticsSummaryApiAiGatewayAnalyticsSummaryGetRequestParams {
  range?: string;
  /** ISO 8601 window start; with dateTo, overrides range (arbitrary range). */
  dateFrom?: string | null;
  /** ISO 8601 window end; with dateFrom, overrides range (arbitrary range). */
  dateTo?: string | null;
  compare?: string;
  userId?: string | null;
  keyHash?: string | null;
}

export interface AnalyticsSummaryShortAliasAnalyticsSummaryGetRequestParams {
  range?: string;
  /** ISO 8601 window start; with dateTo, overrides range (arbitrary range). */
  dateFrom?: string | null;
  /** ISO 8601 window end; with dateFrom, overrides range (arbitrary range). */
  dateTo?: string | null;
  compare?: string;
  userId?: string | null;
  keyHash?: string | null;
}

export interface AnalyticsTimeseriesApiAiGatewayAnalyticsTimeseriesGetRequestParams {
  metric?: string;
  range?: string;
  /** ISO 8601 window start; with dateTo, overrides range (arbitrary range). */
  dateFrom?: string | null;
  /** ISO 8601 window end; with dateFrom, overrides range (arbitrary range). */
  dateTo?: string | null;
  interval?: string;
  userId?: string | null;
  keyHash?: string | null;
  compare?: string;
}

export interface AnalyticsTimeseriesShortAliasAnalyticsTimeseriesGetRequestParams {
  metric?: string;
  range?: string;
  /** ISO 8601 window start; with dateTo, overrides range (arbitrary range). */
  dateFrom?: string | null;
  /** ISO 8601 window end; with dateFrom, overrides range (arbitrary range). */
  dateTo?: string | null;
  interval?: string;
  userId?: string | null;
  keyHash?: string | null;
  compare?: string;
}

export interface LatencyTimeseriesApiAiGatewayAnalyticsLatencyTimeseriesGetRequestParams {
  range?: string;
  /** ISO 8601 window start; with dateTo, overrides range (arbitrary range). */
  dateFrom?: string | null;
  /** ISO 8601 window end; with dateFrom, overrides range (arbitrary range). */
  dateTo?: string | null;
  interval?: string;
  percentiles?: string;
  userId?: string | null;
}

export interface LatencyTimeseriesShortAliasAnalyticsLatencyTimeseriesGetRequestParams {
  range?: string;
  /** ISO 8601 window start; with dateTo, overrides range (arbitrary range). */
  dateFrom?: string | null;
  /** ISO 8601 window end; with dateFrom, overrides range (arbitrary range). */
  dateTo?: string | null;
  interval?: string;
  percentiles?: string;
  userId?: string | null;
}

export interface ModelsCatalogApiAiGatewayModelsCatalogGetRequestParams {
  category?: string;
  search?: string;
  sort?: string;
  page?: number;
  perPage?: number;
}

export interface ModelsCatalogShortAliasModelsCatalogGetRequestParams {
  category?: string;
  search?: string;
  sort?: string;
  page?: number;
  perPage?: number;
}

export interface ProviderDistributionApiAiGatewayAnalyticsProviderDistributionGetRequestParams {
  range?: string;
  /** ISO 8601 window start; with dateTo, overrides range (arbitrary range). */
  dateFrom?: string | null;
  /** ISO 8601 window end; with dateFrom, overrides range (arbitrary range). */
  dateTo?: string | null;
  userId?: string | null;
}

export interface ProviderDistributionShortAliasAnalyticsProviderDistributionGetRequestParams {
  range?: string;
  /** ISO 8601 window start; with dateTo, overrides range (arbitrary range). */
  dateFrom?: string | null;
  /** ISO 8601 window end; with dateFrom, overrides range (arbitrary range). */
  dateTo?: string | null;
  userId?: string | null;
}

export interface QuickStatsApiAiGatewayAnalyticsQuickStatsGetRequestParams {
  range?: string;
  /** ISO 8601 window start; with dateTo, overrides range (arbitrary range). */
  dateFrom?: string | null;
  /** ISO 8601 window end; with dateFrom, overrides range (arbitrary range). */
  dateTo?: string | null;
  userId?: string | null;
}

export interface QuickStatsShortAliasAnalyticsQuickStatsGetRequestParams {
  range?: string;
  /** ISO 8601 window start; with dateTo, overrides range (arbitrary range). */
  dateFrom?: string | null;
  /** ISO 8601 window end; with dateFrom, overrides range (arbitrary range). */
  dateTo?: string | null;
  userId?: string | null;
}

export interface TopKeysApiAiGatewayAnalyticsTopKeysGetRequestParams {
  metric?: string;
  range?: string;
  /** ISO 8601 window start; with dateTo, overrides range (arbitrary range). */
  dateFrom?: string | null;
  /** ISO 8601 window end; with dateFrom, overrides range (arbitrary range). */
  dateTo?: string | null;
  limit?: number;
  userId?: string | null;
}

export interface TopKeysShortAliasAnalyticsTopKeysGetRequestParams {
  metric?: string;
  range?: string;
  /** ISO 8601 window start; with dateTo, overrides range (arbitrary range). */
  dateFrom?: string | null;
  /** ISO 8601 window end; with dateFrom, overrides range (arbitrary range). */
  dateTo?: string | null;
  limit?: number;
  userId?: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  protected basePath = 'http://localhost';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
      if (firstBasePath != undefined) {
        basePath = firstBasePath;
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  // @ts-ignore
  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach((elem) => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach((k) => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k)));
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * Get budget projection
   * Returns spend, caller budget when available, projected spend, and budget status. Params: range, userId (accepted but ignored; results always scoped to the calling user, admins included), and an optional keyHash. With keyHash, spend and projected are narrowed to that one of the caller\&#39;s OWN keys (a foreign keyHash returns zero spend) and budget is null -- this service cannot source a per-key max_budget, so the UI overlays the key budget it already holds from /apikeys. current_month projection uses the real month length.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @deprecated
   */
  public analyticsBudgetApiAiGatewayAnalyticsBudgetGet(
    requestParameters?: AnalyticsBudgetApiAiGatewayAnalyticsBudgetGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<AnalyticsEnvelope>;
  public analyticsBudgetApiAiGatewayAnalyticsBudgetGet(
    requestParameters?: AnalyticsBudgetApiAiGatewayAnalyticsBudgetGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<AnalyticsEnvelope>>;
  public analyticsBudgetApiAiGatewayAnalyticsBudgetGet(
    requestParameters?: AnalyticsBudgetApiAiGatewayAnalyticsBudgetGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<AnalyticsEnvelope>>;
  public analyticsBudgetApiAiGatewayAnalyticsBudgetGet(
    requestParameters?: AnalyticsBudgetApiAiGatewayAnalyticsBudgetGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const range = requestParameters?.range;
    const dateFrom = requestParameters?.dateFrom;
    const dateTo = requestParameters?.dateTo;
    const userId = requestParameters?.userId;
    const keyHash = requestParameters?.keyHash;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (range !== undefined && range !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>range, 'range');
    }
    if (dateFrom !== undefined && dateFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateFrom, 'dateFrom');
    }
    if (dateTo !== undefined && dateTo !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateTo, 'dateTo');
    }
    if (userId !== undefined && userId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>userId, 'userId');
    }
    if (keyHash !== undefined && keyHash !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>keyHash, 'keyHash');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/ai-gateway/analytics/budget`;
    return this.httpClient.request<AnalyticsEnvelope>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Get budget projection
   * Returns spend, caller budget when available, projected spend, and budget status. Params: range, userId (accepted but ignored; results always scoped to the calling user, admins included), and an optional keyHash. With keyHash, spend and projected are narrowed to that one of the caller\&#39;s OWN keys (a foreign keyHash returns zero spend) and budget is null -- this service cannot source a per-key max_budget, so the UI overlays the key budget it already holds from /apikeys. current_month projection uses the real month length.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public analyticsBudgetShortAliasAnalyticsBudgetGet(
    requestParameters?: AnalyticsBudgetShortAliasAnalyticsBudgetGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<AnalyticsEnvelope>;
  public analyticsBudgetShortAliasAnalyticsBudgetGet(
    requestParameters?: AnalyticsBudgetShortAliasAnalyticsBudgetGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<AnalyticsEnvelope>>;
  public analyticsBudgetShortAliasAnalyticsBudgetGet(
    requestParameters?: AnalyticsBudgetShortAliasAnalyticsBudgetGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<AnalyticsEnvelope>>;
  public analyticsBudgetShortAliasAnalyticsBudgetGet(
    requestParameters?: AnalyticsBudgetShortAliasAnalyticsBudgetGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const range = requestParameters?.range;
    const dateFrom = requestParameters?.dateFrom;
    const dateTo = requestParameters?.dateTo;
    const userId = requestParameters?.userId;
    const keyHash = requestParameters?.keyHash;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (range !== undefined && range !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>range, 'range');
    }
    if (dateFrom !== undefined && dateFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateFrom, 'dateFrom');
    }
    if (dateTo !== undefined && dateTo !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateTo, 'dateTo');
    }
    if (userId !== undefined && userId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>userId, 'userId');
    }
    if (keyHash !== undefined && keyHash !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>keyHash, 'keyHash');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/analytics/budget`;
    return this.httpClient.request<AnalyticsEnvelope>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Get endpoint analytics
   * Returns top API endpoint usage with request counts and average latency. Params: range, limit, and userId, which is accepted but ignored -- results are always scoped to the calling user, admins included.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @deprecated
   */
  public analyticsEndpointsApiAiGatewayAnalyticsEndpointsGet(
    requestParameters?: AnalyticsEndpointsApiAiGatewayAnalyticsEndpointsGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<AnalyticsEnvelope>;
  public analyticsEndpointsApiAiGatewayAnalyticsEndpointsGet(
    requestParameters?: AnalyticsEndpointsApiAiGatewayAnalyticsEndpointsGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<AnalyticsEnvelope>>;
  public analyticsEndpointsApiAiGatewayAnalyticsEndpointsGet(
    requestParameters?: AnalyticsEndpointsApiAiGatewayAnalyticsEndpointsGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<AnalyticsEnvelope>>;
  public analyticsEndpointsApiAiGatewayAnalyticsEndpointsGet(
    requestParameters?: AnalyticsEndpointsApiAiGatewayAnalyticsEndpointsGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const range = requestParameters?.range;
    const dateFrom = requestParameters?.dateFrom;
    const dateTo = requestParameters?.dateTo;
    const limit = requestParameters?.limit;
    const userId = requestParameters?.userId;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (range !== undefined && range !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>range, 'range');
    }
    if (dateFrom !== undefined && dateFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateFrom, 'dateFrom');
    }
    if (dateTo !== undefined && dateTo !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateTo, 'dateTo');
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }
    if (userId !== undefined && userId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>userId, 'userId');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/ai-gateway/analytics/endpoints`;
    return this.httpClient.request<AnalyticsEnvelope>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Get endpoint analytics
   * Returns top API endpoint usage with request counts and average latency. Params: range, limit, and userId, which is accepted but ignored -- results are always scoped to the calling user, admins included.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public analyticsEndpointsShortAliasAnalyticsEndpointsGet(
    requestParameters?: AnalyticsEndpointsShortAliasAnalyticsEndpointsGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<AnalyticsEnvelope>;
  public analyticsEndpointsShortAliasAnalyticsEndpointsGet(
    requestParameters?: AnalyticsEndpointsShortAliasAnalyticsEndpointsGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<AnalyticsEnvelope>>;
  public analyticsEndpointsShortAliasAnalyticsEndpointsGet(
    requestParameters?: AnalyticsEndpointsShortAliasAnalyticsEndpointsGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<AnalyticsEnvelope>>;
  public analyticsEndpointsShortAliasAnalyticsEndpointsGet(
    requestParameters?: AnalyticsEndpointsShortAliasAnalyticsEndpointsGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const range = requestParameters?.range;
    const dateFrom = requestParameters?.dateFrom;
    const dateTo = requestParameters?.dateTo;
    const limit = requestParameters?.limit;
    const userId = requestParameters?.userId;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (range !== undefined && range !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>range, 'range');
    }
    if (dateFrom !== undefined && dateFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateFrom, 'dateFrom');
    }
    if (dateTo !== undefined && dateTo !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateTo, 'dateTo');
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }
    if (userId !== undefined && userId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>userId, 'userId');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/analytics/endpoints`;
    return this.httpClient.request<AnalyticsEnvelope>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Get error analytics
   * Returns grouped error counts plus a headline errorRate (errorCount / totalRequests over the same scoped window, counted exactly rather than summed from the LIMIT-capped groups). Params: range, groupBy (status_code, error_type, provider, or model), userId (accepted but ignored -- results are always scoped to the calling user, admins included), and an optional keyHash that narrows to one of the caller\&#39;s OWN keys (a foreign keyHash returns no data).
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @deprecated
   */
  public analyticsErrorsApiAiGatewayAnalyticsErrorsGet(
    requestParameters?: AnalyticsErrorsApiAiGatewayAnalyticsErrorsGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<AnalyticsEnvelope>;
  public analyticsErrorsApiAiGatewayAnalyticsErrorsGet(
    requestParameters?: AnalyticsErrorsApiAiGatewayAnalyticsErrorsGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<AnalyticsEnvelope>>;
  public analyticsErrorsApiAiGatewayAnalyticsErrorsGet(
    requestParameters?: AnalyticsErrorsApiAiGatewayAnalyticsErrorsGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<AnalyticsEnvelope>>;
  public analyticsErrorsApiAiGatewayAnalyticsErrorsGet(
    requestParameters?: AnalyticsErrorsApiAiGatewayAnalyticsErrorsGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const range = requestParameters?.range;
    const dateFrom = requestParameters?.dateFrom;
    const dateTo = requestParameters?.dateTo;
    const groupBy = requestParameters?.groupBy;
    const userId = requestParameters?.userId;
    const keyHash = requestParameters?.keyHash;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (range !== undefined && range !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>range, 'range');
    }
    if (dateFrom !== undefined && dateFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateFrom, 'dateFrom');
    }
    if (dateTo !== undefined && dateTo !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateTo, 'dateTo');
    }
    if (groupBy !== undefined && groupBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>groupBy, 'groupBy');
    }
    if (userId !== undefined && userId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>userId, 'userId');
    }
    if (keyHash !== undefined && keyHash !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>keyHash, 'keyHash');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/ai-gateway/analytics/errors`;
    return this.httpClient.request<AnalyticsEnvelope>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Get error analytics
   * Returns grouped error counts plus a headline errorRate (errorCount / totalRequests over the same scoped window, counted exactly rather than summed from the LIMIT-capped groups). Params: range, groupBy (status_code, error_type, provider, or model), userId (accepted but ignored -- results are always scoped to the calling user, admins included), and an optional keyHash that narrows to one of the caller\&#39;s OWN keys (a foreign keyHash returns no data).
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public analyticsErrorsShortAliasAnalyticsErrorsGet(
    requestParameters?: AnalyticsErrorsShortAliasAnalyticsErrorsGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<AnalyticsEnvelope>;
  public analyticsErrorsShortAliasAnalyticsErrorsGet(
    requestParameters?: AnalyticsErrorsShortAliasAnalyticsErrorsGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<AnalyticsEnvelope>>;
  public analyticsErrorsShortAliasAnalyticsErrorsGet(
    requestParameters?: AnalyticsErrorsShortAliasAnalyticsErrorsGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<AnalyticsEnvelope>>;
  public analyticsErrorsShortAliasAnalyticsErrorsGet(
    requestParameters?: AnalyticsErrorsShortAliasAnalyticsErrorsGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const range = requestParameters?.range;
    const dateFrom = requestParameters?.dateFrom;
    const dateTo = requestParameters?.dateTo;
    const groupBy = requestParameters?.groupBy;
    const userId = requestParameters?.userId;
    const keyHash = requestParameters?.keyHash;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (range !== undefined && range !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>range, 'range');
    }
    if (dateFrom !== undefined && dateFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateFrom, 'dateFrom');
    }
    if (dateTo !== undefined && dateTo !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateTo, 'dateTo');
    }
    if (groupBy !== undefined && groupBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>groupBy, 'groupBy');
    }
    if (userId !== undefined && userId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>userId, 'userId');
    }
    if (keyHash !== undefined && keyHash !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>keyHash, 'keyHash');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/analytics/errors`;
    return this.httpClient.request<AnalyticsEnvelope>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * List API key analytics
   * Returns paginated per-key analytics for requests, tokens, spend, and last usage. Params: page, perPage, range, and userId, which is accepted but ignored -- results are always scoped to the calling user, admins included. Each row\&#39;s keyHash is the 16-hex per-key identifier (the request-log hash); pass THAT value as the keyHash filter on the other analytics endpoints to narrow to a single key. It is NOT the /apikeys key_id -- the key_id is not the narrowing identifier.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @deprecated
   */
  public analyticsKeysApiAiGatewayAnalyticsKeysGet(
    requestParameters?: AnalyticsKeysApiAiGatewayAnalyticsKeysGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<AnalyticsEnvelope>;
  public analyticsKeysApiAiGatewayAnalyticsKeysGet(
    requestParameters?: AnalyticsKeysApiAiGatewayAnalyticsKeysGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<AnalyticsEnvelope>>;
  public analyticsKeysApiAiGatewayAnalyticsKeysGet(
    requestParameters?: AnalyticsKeysApiAiGatewayAnalyticsKeysGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<AnalyticsEnvelope>>;
  public analyticsKeysApiAiGatewayAnalyticsKeysGet(
    requestParameters?: AnalyticsKeysApiAiGatewayAnalyticsKeysGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const page = requestParameters?.page;
    const perPage = requestParameters?.perPage;
    const range = requestParameters?.range;
    const dateFrom = requestParameters?.dateFrom;
    const dateTo = requestParameters?.dateTo;
    const userId = requestParameters?.userId;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'page');
    }
    if (perPage !== undefined && perPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>perPage, 'perPage');
    }
    if (range !== undefined && range !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>range, 'range');
    }
    if (dateFrom !== undefined && dateFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateFrom, 'dateFrom');
    }
    if (dateTo !== undefined && dateTo !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateTo, 'dateTo');
    }
    if (userId !== undefined && userId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>userId, 'userId');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/ai-gateway/analytics/keys`;
    return this.httpClient.request<AnalyticsEnvelope>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * List API key analytics
   * Returns paginated per-key analytics for requests, tokens, spend, and last usage. Params: page, perPage, range, and userId, which is accepted but ignored -- results are always scoped to the calling user, admins included. Each row\&#39;s keyHash is the 16-hex per-key identifier (the request-log hash); pass THAT value as the keyHash filter on the other analytics endpoints to narrow to a single key. It is NOT the /apikeys key_id -- the key_id is not the narrowing identifier.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public analyticsKeysShortAliasAnalyticsKeysGet(
    requestParameters?: AnalyticsKeysShortAliasAnalyticsKeysGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<AnalyticsEnvelope>;
  public analyticsKeysShortAliasAnalyticsKeysGet(
    requestParameters?: AnalyticsKeysShortAliasAnalyticsKeysGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<AnalyticsEnvelope>>;
  public analyticsKeysShortAliasAnalyticsKeysGet(
    requestParameters?: AnalyticsKeysShortAliasAnalyticsKeysGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<AnalyticsEnvelope>>;
  public analyticsKeysShortAliasAnalyticsKeysGet(
    requestParameters?: AnalyticsKeysShortAliasAnalyticsKeysGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const page = requestParameters?.page;
    const perPage = requestParameters?.perPage;
    const range = requestParameters?.range;
    const dateFrom = requestParameters?.dateFrom;
    const dateTo = requestParameters?.dateTo;
    const userId = requestParameters?.userId;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'page');
    }
    if (perPage !== undefined && perPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>perPage, 'perPage');
    }
    if (range !== undefined && range !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>range, 'range');
    }
    if (dateFrom !== undefined && dateFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateFrom, 'dateFrom');
    }
    if (dateTo !== undefined && dateTo !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateTo, 'dateTo');
    }
    if (userId !== undefined && userId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>userId, 'userId');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/analytics/keys`;
    return this.httpClient.request<AnalyticsEnvelope>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Get model analytics
   * Returns per-model requests, tokens, average latency, spend, traffic percentage, cachedPct (cache hits / requests), errorRate (non-success / requests), and cacheSavedUsd (net USD the provider prompt-cache saved for this model over the scoped window). Params: range, sort, limit, userId (accepted but ignored; results always scoped to the calling user, admins included), and an optional keyHash that narrows to one of the caller\&#39;s OWN keys (a foreign keyHash returns no data). trafficPct uses the full scoped range as denominator, not only returned top-N rows.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @deprecated
   */
  public analyticsModelsApiAiGatewayAnalyticsModelsGet(
    requestParameters?: AnalyticsModelsApiAiGatewayAnalyticsModelsGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<AnalyticsEnvelope>;
  public analyticsModelsApiAiGatewayAnalyticsModelsGet(
    requestParameters?: AnalyticsModelsApiAiGatewayAnalyticsModelsGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<AnalyticsEnvelope>>;
  public analyticsModelsApiAiGatewayAnalyticsModelsGet(
    requestParameters?: AnalyticsModelsApiAiGatewayAnalyticsModelsGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<AnalyticsEnvelope>>;
  public analyticsModelsApiAiGatewayAnalyticsModelsGet(
    requestParameters?: AnalyticsModelsApiAiGatewayAnalyticsModelsGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const range = requestParameters?.range;
    const dateFrom = requestParameters?.dateFrom;
    const dateTo = requestParameters?.dateTo;
    const sort = requestParameters?.sort;
    const limit = requestParameters?.limit;
    const userId = requestParameters?.userId;
    const keyHash = requestParameters?.keyHash;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (range !== undefined && range !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>range, 'range');
    }
    if (dateFrom !== undefined && dateFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateFrom, 'dateFrom');
    }
    if (dateTo !== undefined && dateTo !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateTo, 'dateTo');
    }
    if (sort !== undefined && sort !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sort, 'sort');
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }
    if (userId !== undefined && userId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>userId, 'userId');
    }
    if (keyHash !== undefined && keyHash !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>keyHash, 'keyHash');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/ai-gateway/analytics/models`;
    return this.httpClient.request<AnalyticsEnvelope>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Get model analytics
   * Returns per-model requests, tokens, average latency, spend, traffic percentage, cachedPct (cache hits / requests), errorRate (non-success / requests), and cacheSavedUsd (net USD the provider prompt-cache saved for this model over the scoped window). Params: range, sort, limit, userId (accepted but ignored; results always scoped to the calling user, admins included), and an optional keyHash that narrows to one of the caller\&#39;s OWN keys (a foreign keyHash returns no data). trafficPct uses the full scoped range as denominator, not only returned top-N rows.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public analyticsModelsShortAliasAnalyticsModelsGet(
    requestParameters?: AnalyticsModelsShortAliasAnalyticsModelsGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<AnalyticsEnvelope>;
  public analyticsModelsShortAliasAnalyticsModelsGet(
    requestParameters?: AnalyticsModelsShortAliasAnalyticsModelsGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<AnalyticsEnvelope>>;
  public analyticsModelsShortAliasAnalyticsModelsGet(
    requestParameters?: AnalyticsModelsShortAliasAnalyticsModelsGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<AnalyticsEnvelope>>;
  public analyticsModelsShortAliasAnalyticsModelsGet(
    requestParameters?: AnalyticsModelsShortAliasAnalyticsModelsGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const range = requestParameters?.range;
    const dateFrom = requestParameters?.dateFrom;
    const dateTo = requestParameters?.dateTo;
    const sort = requestParameters?.sort;
    const limit = requestParameters?.limit;
    const userId = requestParameters?.userId;
    const keyHash = requestParameters?.keyHash;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (range !== undefined && range !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>range, 'range');
    }
    if (dateFrom !== undefined && dateFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateFrom, 'dateFrom');
    }
    if (dateTo !== undefined && dateTo !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateTo, 'dateTo');
    }
    if (sort !== undefined && sort !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sort, 'sort');
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }
    if (userId !== undefined && userId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>userId, 'userId');
    }
    if (keyHash !== undefined && keyHash !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>keyHash, 'keyHash');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/analytics/models`;
    return this.httpClient.request<AnalyticsEnvelope>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Get region distribution
   * Returns request distribution by Guardian region. Params: range and userId, which is accepted but ignored -- results are always scoped to the calling user, admins included.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @deprecated
   */
  public analyticsRegionsApiAiGatewayAnalyticsRegionsGet(
    requestParameters?: AnalyticsRegionsApiAiGatewayAnalyticsRegionsGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<AnalyticsEnvelope>;
  public analyticsRegionsApiAiGatewayAnalyticsRegionsGet(
    requestParameters?: AnalyticsRegionsApiAiGatewayAnalyticsRegionsGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<AnalyticsEnvelope>>;
  public analyticsRegionsApiAiGatewayAnalyticsRegionsGet(
    requestParameters?: AnalyticsRegionsApiAiGatewayAnalyticsRegionsGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<AnalyticsEnvelope>>;
  public analyticsRegionsApiAiGatewayAnalyticsRegionsGet(
    requestParameters?: AnalyticsRegionsApiAiGatewayAnalyticsRegionsGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const range = requestParameters?.range;
    const dateFrom = requestParameters?.dateFrom;
    const dateTo = requestParameters?.dateTo;
    const userId = requestParameters?.userId;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (range !== undefined && range !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>range, 'range');
    }
    if (dateFrom !== undefined && dateFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateFrom, 'dateFrom');
    }
    if (dateTo !== undefined && dateTo !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateTo, 'dateTo');
    }
    if (userId !== undefined && userId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>userId, 'userId');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/ai-gateway/analytics/regions`;
    return this.httpClient.request<AnalyticsEnvelope>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Get region distribution
   * Returns request distribution by Guardian region. Params: range and userId, which is accepted but ignored -- results are always scoped to the calling user, admins included.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public analyticsRegionsShortAliasAnalyticsRegionsGet(
    requestParameters?: AnalyticsRegionsShortAliasAnalyticsRegionsGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<AnalyticsEnvelope>;
  public analyticsRegionsShortAliasAnalyticsRegionsGet(
    requestParameters?: AnalyticsRegionsShortAliasAnalyticsRegionsGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<AnalyticsEnvelope>>;
  public analyticsRegionsShortAliasAnalyticsRegionsGet(
    requestParameters?: AnalyticsRegionsShortAliasAnalyticsRegionsGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<AnalyticsEnvelope>>;
  public analyticsRegionsShortAliasAnalyticsRegionsGet(
    requestParameters?: AnalyticsRegionsShortAliasAnalyticsRegionsGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const range = requestParameters?.range;
    const dateFrom = requestParameters?.dateFrom;
    const dateTo = requestParameters?.dateTo;
    const userId = requestParameters?.userId;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (range !== undefined && range !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>range, 'range');
    }
    if (dateFrom !== undefined && dateFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateFrom, 'dateFrom');
    }
    if (dateTo !== undefined && dateTo !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateTo, 'dateTo');
    }
    if (userId !== undefined && userId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>userId, 'userId');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/analytics/regions`;
    return this.httpClient.request<AnalyticsEnvelope>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Get analytics summary
   * Returns aggregate usage metrics plus deltas against the previous period. Params: range, compare, userId (accepted but ignored -- results are always scoped to the calling user, admins included), and an optional keyHash that narrows to a single one of the caller\&#39;s OWN keys for the key-detail view (a keyHash belonging to another user returns no data; ownership is enforced by the always-on user scope).
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @deprecated
   */
  public analyticsSummaryApiAiGatewayAnalyticsSummaryGet(
    requestParameters?: AnalyticsSummaryApiAiGatewayAnalyticsSummaryGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<AnalyticsEnvelope>;
  public analyticsSummaryApiAiGatewayAnalyticsSummaryGet(
    requestParameters?: AnalyticsSummaryApiAiGatewayAnalyticsSummaryGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<AnalyticsEnvelope>>;
  public analyticsSummaryApiAiGatewayAnalyticsSummaryGet(
    requestParameters?: AnalyticsSummaryApiAiGatewayAnalyticsSummaryGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<AnalyticsEnvelope>>;
  public analyticsSummaryApiAiGatewayAnalyticsSummaryGet(
    requestParameters?: AnalyticsSummaryApiAiGatewayAnalyticsSummaryGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const range = requestParameters?.range;
    const dateFrom = requestParameters?.dateFrom;
    const dateTo = requestParameters?.dateTo;
    const compare = requestParameters?.compare;
    const userId = requestParameters?.userId;
    const keyHash = requestParameters?.keyHash;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (range !== undefined && range !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>range, 'range');
    }
    if (dateFrom !== undefined && dateFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateFrom, 'dateFrom');
    }
    if (dateTo !== undefined && dateTo !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateTo, 'dateTo');
    }
    if (compare !== undefined && compare !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>compare, 'compare');
    }
    if (userId !== undefined && userId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>userId, 'userId');
    }
    if (keyHash !== undefined && keyHash !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>keyHash, 'keyHash');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/ai-gateway/analytics/summary`;
    return this.httpClient.request<AnalyticsEnvelope>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Get analytics summary
   * Returns aggregate usage metrics plus deltas against the previous period. Params: range, compare, userId (accepted but ignored -- results are always scoped to the calling user, admins included), and an optional keyHash that narrows to a single one of the caller\&#39;s OWN keys for the key-detail view (a keyHash belonging to another user returns no data; ownership is enforced by the always-on user scope).
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public analyticsSummaryShortAliasAnalyticsSummaryGet(
    requestParameters?: AnalyticsSummaryShortAliasAnalyticsSummaryGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<AnalyticsEnvelope>;
  public analyticsSummaryShortAliasAnalyticsSummaryGet(
    requestParameters?: AnalyticsSummaryShortAliasAnalyticsSummaryGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<AnalyticsEnvelope>>;
  public analyticsSummaryShortAliasAnalyticsSummaryGet(
    requestParameters?: AnalyticsSummaryShortAliasAnalyticsSummaryGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<AnalyticsEnvelope>>;
  public analyticsSummaryShortAliasAnalyticsSummaryGet(
    requestParameters?: AnalyticsSummaryShortAliasAnalyticsSummaryGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const range = requestParameters?.range;
    const dateFrom = requestParameters?.dateFrom;
    const dateTo = requestParameters?.dateTo;
    const compare = requestParameters?.compare;
    const userId = requestParameters?.userId;
    const keyHash = requestParameters?.keyHash;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (range !== undefined && range !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>range, 'range');
    }
    if (dateFrom !== undefined && dateFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateFrom, 'dateFrom');
    }
    if (dateTo !== undefined && dateTo !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateTo, 'dateTo');
    }
    if (compare !== undefined && compare !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>compare, 'compare');
    }
    if (userId !== undefined && userId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>userId, 'userId');
    }
    if (keyHash !== undefined && keyHash !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>keyHash, 'keyHash');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/analytics/summary`;
    return this.httpClient.request<AnalyticsEnvelope>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Get analytics time series
   * Returns time-series points for requests, spend, or cache hit rate. Params: metric, range, interval, userId (accepted but ignored -- results are always scoped to the calling user, admins included), an optional keyHash that narrows to one of the caller\&#39;s OWN keys (a foreign keyHash returns no data), and compare: when compare&#x3D;previous_period the response adds a previousPoints array (the same-length span immediately before) for the this-vs-previous overlay.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @deprecated
   */
  public analyticsTimeseriesApiAiGatewayAnalyticsTimeseriesGet(
    requestParameters?: AnalyticsTimeseriesApiAiGatewayAnalyticsTimeseriesGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<AnalyticsEnvelope>;
  public analyticsTimeseriesApiAiGatewayAnalyticsTimeseriesGet(
    requestParameters?: AnalyticsTimeseriesApiAiGatewayAnalyticsTimeseriesGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<AnalyticsEnvelope>>;
  public analyticsTimeseriesApiAiGatewayAnalyticsTimeseriesGet(
    requestParameters?: AnalyticsTimeseriesApiAiGatewayAnalyticsTimeseriesGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<AnalyticsEnvelope>>;
  public analyticsTimeseriesApiAiGatewayAnalyticsTimeseriesGet(
    requestParameters?: AnalyticsTimeseriesApiAiGatewayAnalyticsTimeseriesGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const metric = requestParameters?.metric;
    const range = requestParameters?.range;
    const dateFrom = requestParameters?.dateFrom;
    const dateTo = requestParameters?.dateTo;
    const interval = requestParameters?.interval;
    const userId = requestParameters?.userId;
    const keyHash = requestParameters?.keyHash;
    const compare = requestParameters?.compare;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (metric !== undefined && metric !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>metric, 'metric');
    }
    if (range !== undefined && range !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>range, 'range');
    }
    if (dateFrom !== undefined && dateFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateFrom, 'dateFrom');
    }
    if (dateTo !== undefined && dateTo !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateTo, 'dateTo');
    }
    if (interval !== undefined && interval !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>interval, 'interval');
    }
    if (userId !== undefined && userId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>userId, 'userId');
    }
    if (keyHash !== undefined && keyHash !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>keyHash, 'keyHash');
    }
    if (compare !== undefined && compare !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>compare, 'compare');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/ai-gateway/analytics/timeseries`;
    return this.httpClient.request<AnalyticsEnvelope>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Get analytics time series
   * Returns time-series points for requests, spend, or cache hit rate. Params: metric, range, interval, userId (accepted but ignored -- results are always scoped to the calling user, admins included), an optional keyHash that narrows to one of the caller\&#39;s OWN keys (a foreign keyHash returns no data), and compare: when compare&#x3D;previous_period the response adds a previousPoints array (the same-length span immediately before) for the this-vs-previous overlay.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public analyticsTimeseriesShortAliasAnalyticsTimeseriesGet(
    requestParameters?: AnalyticsTimeseriesShortAliasAnalyticsTimeseriesGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<AnalyticsEnvelope>;
  public analyticsTimeseriesShortAliasAnalyticsTimeseriesGet(
    requestParameters?: AnalyticsTimeseriesShortAliasAnalyticsTimeseriesGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<AnalyticsEnvelope>>;
  public analyticsTimeseriesShortAliasAnalyticsTimeseriesGet(
    requestParameters?: AnalyticsTimeseriesShortAliasAnalyticsTimeseriesGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<AnalyticsEnvelope>>;
  public analyticsTimeseriesShortAliasAnalyticsTimeseriesGet(
    requestParameters?: AnalyticsTimeseriesShortAliasAnalyticsTimeseriesGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const metric = requestParameters?.metric;
    const range = requestParameters?.range;
    const dateFrom = requestParameters?.dateFrom;
    const dateTo = requestParameters?.dateTo;
    const interval = requestParameters?.interval;
    const userId = requestParameters?.userId;
    const keyHash = requestParameters?.keyHash;
    const compare = requestParameters?.compare;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (metric !== undefined && metric !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>metric, 'metric');
    }
    if (range !== undefined && range !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>range, 'range');
    }
    if (dateFrom !== undefined && dateFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateFrom, 'dateFrom');
    }
    if (dateTo !== undefined && dateTo !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateTo, 'dateTo');
    }
    if (interval !== undefined && interval !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>interval, 'interval');
    }
    if (userId !== undefined && userId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>userId, 'userId');
    }
    if (keyHash !== undefined && keyHash !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>keyHash, 'keyHash');
    }
    if (compare !== undefined && compare !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>compare, 'compare');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/analytics/timeseries`;
    return this.httpClient.request<AnalyticsEnvelope>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Get UI client configuration
   * Returns frontend connection metadata such as gateway base URL, model catalog URL, default model, and auth header format. Requires authentication.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @deprecated
   */
  public clientConfigApiAiGatewayClientConfigGet(
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<AnalyticsEnvelope>;
  public clientConfigApiAiGatewayClientConfigGet(
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<AnalyticsEnvelope>>;
  public clientConfigApiAiGatewayClientConfigGet(
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<AnalyticsEnvelope>>;
  public clientConfigApiAiGatewayClientConfigGet(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/ai-gateway/client-config`;
    return this.httpClient.request<AnalyticsEnvelope>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Get UI client configuration
   * Returns frontend connection metadata such as gateway base URL, model catalog URL, default model, and auth header format. Requires authentication.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public clientConfigShortAliasClientConfigGet(
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<AnalyticsEnvelope>;
  public clientConfigShortAliasClientConfigGet(
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<AnalyticsEnvelope>>;
  public clientConfigShortAliasClientConfigGet(
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<AnalyticsEnvelope>>;
  public clientConfigShortAliasClientConfigGet(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/client-config`;
    return this.httpClient.request<AnalyticsEnvelope>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Get latency time series
   * Returns latency buckets with average, max, and requested percentiles. Params: range, interval, percentiles, and userId, which is accepted but ignored -- results are always scoped to the calling user, admins included.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @deprecated
   */
  public latencyTimeseriesApiAiGatewayAnalyticsLatencyTimeseriesGet(
    requestParameters?: LatencyTimeseriesApiAiGatewayAnalyticsLatencyTimeseriesGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<AnalyticsEnvelope>;
  public latencyTimeseriesApiAiGatewayAnalyticsLatencyTimeseriesGet(
    requestParameters?: LatencyTimeseriesApiAiGatewayAnalyticsLatencyTimeseriesGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<AnalyticsEnvelope>>;
  public latencyTimeseriesApiAiGatewayAnalyticsLatencyTimeseriesGet(
    requestParameters?: LatencyTimeseriesApiAiGatewayAnalyticsLatencyTimeseriesGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<AnalyticsEnvelope>>;
  public latencyTimeseriesApiAiGatewayAnalyticsLatencyTimeseriesGet(
    requestParameters?: LatencyTimeseriesApiAiGatewayAnalyticsLatencyTimeseriesGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const range = requestParameters?.range;
    const dateFrom = requestParameters?.dateFrom;
    const dateTo = requestParameters?.dateTo;
    const interval = requestParameters?.interval;
    const percentiles = requestParameters?.percentiles;
    const userId = requestParameters?.userId;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (range !== undefined && range !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>range, 'range');
    }
    if (dateFrom !== undefined && dateFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateFrom, 'dateFrom');
    }
    if (dateTo !== undefined && dateTo !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateTo, 'dateTo');
    }
    if (interval !== undefined && interval !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>interval, 'interval');
    }
    if (percentiles !== undefined && percentiles !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>percentiles, 'percentiles');
    }
    if (userId !== undefined && userId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>userId, 'userId');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/ai-gateway/analytics/latency-timeseries`;
    return this.httpClient.request<AnalyticsEnvelope>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Get latency time series
   * Returns latency buckets with average, max, and requested percentiles. Params: range, interval, percentiles, and userId, which is accepted but ignored -- results are always scoped to the calling user, admins included.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public latencyTimeseriesShortAliasAnalyticsLatencyTimeseriesGet(
    requestParameters?: LatencyTimeseriesShortAliasAnalyticsLatencyTimeseriesGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<AnalyticsEnvelope>;
  public latencyTimeseriesShortAliasAnalyticsLatencyTimeseriesGet(
    requestParameters?: LatencyTimeseriesShortAliasAnalyticsLatencyTimeseriesGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<AnalyticsEnvelope>>;
  public latencyTimeseriesShortAliasAnalyticsLatencyTimeseriesGet(
    requestParameters?: LatencyTimeseriesShortAliasAnalyticsLatencyTimeseriesGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<AnalyticsEnvelope>>;
  public latencyTimeseriesShortAliasAnalyticsLatencyTimeseriesGet(
    requestParameters?: LatencyTimeseriesShortAliasAnalyticsLatencyTimeseriesGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const range = requestParameters?.range;
    const dateFrom = requestParameters?.dateFrom;
    const dateTo = requestParameters?.dateTo;
    const interval = requestParameters?.interval;
    const percentiles = requestParameters?.percentiles;
    const userId = requestParameters?.userId;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (range !== undefined && range !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>range, 'range');
    }
    if (dateFrom !== undefined && dateFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateFrom, 'dateFrom');
    }
    if (dateTo !== undefined && dateTo !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateTo, 'dateTo');
    }
    if (interval !== undefined && interval !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>interval, 'interval');
    }
    if (percentiles !== undefined && percentiles !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>percentiles, 'percentiles');
    }
    if (userId !== undefined && userId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>userId, 'userId');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/analytics/latency-timeseries`;
    return this.httpClient.request<AnalyticsEnvelope>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * List model catalog
   * Returns model catalog entries with provider, category, pricing, context, a deterministic displayName, and a factual description. Params: category, search, sort (id or most_used -- most_used orders by the caller\&#39;s OWN request volume, user-scoped), page, and perPage. Requires authentication.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @deprecated
   */
  public modelsCatalogApiAiGatewayModelsCatalogGet(
    requestParameters?: ModelsCatalogApiAiGatewayModelsCatalogGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<AnalyticsEnvelope>;
  public modelsCatalogApiAiGatewayModelsCatalogGet(
    requestParameters?: ModelsCatalogApiAiGatewayModelsCatalogGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<AnalyticsEnvelope>>;
  public modelsCatalogApiAiGatewayModelsCatalogGet(
    requestParameters?: ModelsCatalogApiAiGatewayModelsCatalogGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<AnalyticsEnvelope>>;
  public modelsCatalogApiAiGatewayModelsCatalogGet(
    requestParameters?: ModelsCatalogApiAiGatewayModelsCatalogGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const category = requestParameters?.category;
    const search = requestParameters?.search;
    const sort = requestParameters?.sort;
    const page = requestParameters?.page;
    const perPage = requestParameters?.perPage;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (category !== undefined && category !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>category, 'category');
    }
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'search');
    }
    if (sort !== undefined && sort !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sort, 'sort');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'page');
    }
    if (perPage !== undefined && perPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>perPage, 'perPage');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/ai-gateway/models/catalog`;
    return this.httpClient.request<AnalyticsEnvelope>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * List model catalog
   * Returns model catalog entries with provider, category, pricing, context, a deterministic displayName, and a factual description. Params: category, search, sort (id or most_used -- most_used orders by the caller\&#39;s OWN request volume, user-scoped), page, and perPage. Requires authentication.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @deprecated
   */
  public modelsCatalogShortAliasModelsCatalogGet(
    requestParameters?: ModelsCatalogShortAliasModelsCatalogGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<AnalyticsEnvelope>;
  public modelsCatalogShortAliasModelsCatalogGet(
    requestParameters?: ModelsCatalogShortAliasModelsCatalogGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<AnalyticsEnvelope>>;
  public modelsCatalogShortAliasModelsCatalogGet(
    requestParameters?: ModelsCatalogShortAliasModelsCatalogGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<AnalyticsEnvelope>>;
  public modelsCatalogShortAliasModelsCatalogGet(
    requestParameters?: ModelsCatalogShortAliasModelsCatalogGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const category = requestParameters?.category;
    const search = requestParameters?.search;
    const sort = requestParameters?.sort;
    const page = requestParameters?.page;
    const perPage = requestParameters?.perPage;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (category !== undefined && category !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>category, 'category');
    }
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'search');
    }
    if (sort !== undefined && sort !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sort, 'sort');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'page');
    }
    if (perPage !== undefined && perPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>perPage, 'perPage');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/models/catalog`;
    return this.httpClient.request<AnalyticsEnvelope>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Get provider distribution
   * Returns request, model, spend, and traffic percentage breakdown by provider. Params: range and userId, which is accepted but ignored -- results are always scoped to the calling user, admins included.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @deprecated
   */
  public providerDistributionApiAiGatewayAnalyticsProviderDistributionGet(
    requestParameters?: ProviderDistributionApiAiGatewayAnalyticsProviderDistributionGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<AnalyticsEnvelope>;
  public providerDistributionApiAiGatewayAnalyticsProviderDistributionGet(
    requestParameters?: ProviderDistributionApiAiGatewayAnalyticsProviderDistributionGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<AnalyticsEnvelope>>;
  public providerDistributionApiAiGatewayAnalyticsProviderDistributionGet(
    requestParameters?: ProviderDistributionApiAiGatewayAnalyticsProviderDistributionGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<AnalyticsEnvelope>>;
  public providerDistributionApiAiGatewayAnalyticsProviderDistributionGet(
    requestParameters?: ProviderDistributionApiAiGatewayAnalyticsProviderDistributionGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const range = requestParameters?.range;
    const dateFrom = requestParameters?.dateFrom;
    const dateTo = requestParameters?.dateTo;
    const userId = requestParameters?.userId;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (range !== undefined && range !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>range, 'range');
    }
    if (dateFrom !== undefined && dateFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateFrom, 'dateFrom');
    }
    if (dateTo !== undefined && dateTo !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateTo, 'dateTo');
    }
    if (userId !== undefined && userId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>userId, 'userId');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/ai-gateway/analytics/provider-distribution`;
    return this.httpClient.request<AnalyticsEnvelope>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Get provider distribution
   * Returns request, model, spend, and traffic percentage breakdown by provider. Params: range and userId, which is accepted but ignored -- results are always scoped to the calling user, admins included.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public providerDistributionShortAliasAnalyticsProviderDistributionGet(
    requestParameters?: ProviderDistributionShortAliasAnalyticsProviderDistributionGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<AnalyticsEnvelope>;
  public providerDistributionShortAliasAnalyticsProviderDistributionGet(
    requestParameters?: ProviderDistributionShortAliasAnalyticsProviderDistributionGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<AnalyticsEnvelope>>;
  public providerDistributionShortAliasAnalyticsProviderDistributionGet(
    requestParameters?: ProviderDistributionShortAliasAnalyticsProviderDistributionGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<AnalyticsEnvelope>>;
  public providerDistributionShortAliasAnalyticsProviderDistributionGet(
    requestParameters?: ProviderDistributionShortAliasAnalyticsProviderDistributionGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const range = requestParameters?.range;
    const dateFrom = requestParameters?.dateFrom;
    const dateTo = requestParameters?.dateTo;
    const userId = requestParameters?.userId;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (range !== undefined && range !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>range, 'range');
    }
    if (dateFrom !== undefined && dateFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateFrom, 'dateFrom');
    }
    if (dateTo !== undefined && dateTo !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateTo, 'dateTo');
    }
    if (userId !== undefined && userId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>userId, 'userId');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/analytics/provider-distribution`;
    return this.httpClient.request<AnalyticsEnvelope>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Get analytics quick stats
   * Returns request count, spend, model count, token count, cache hit rate, and active key count for a range. Params: range and userId, which is accepted but ignored -- results are always scoped to the calling user, admins included.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @deprecated
   */
  public quickStatsApiAiGatewayAnalyticsQuickStatsGet(
    requestParameters?: QuickStatsApiAiGatewayAnalyticsQuickStatsGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<AnalyticsEnvelope>;
  public quickStatsApiAiGatewayAnalyticsQuickStatsGet(
    requestParameters?: QuickStatsApiAiGatewayAnalyticsQuickStatsGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<AnalyticsEnvelope>>;
  public quickStatsApiAiGatewayAnalyticsQuickStatsGet(
    requestParameters?: QuickStatsApiAiGatewayAnalyticsQuickStatsGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<AnalyticsEnvelope>>;
  public quickStatsApiAiGatewayAnalyticsQuickStatsGet(
    requestParameters?: QuickStatsApiAiGatewayAnalyticsQuickStatsGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const range = requestParameters?.range;
    const dateFrom = requestParameters?.dateFrom;
    const dateTo = requestParameters?.dateTo;
    const userId = requestParameters?.userId;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (range !== undefined && range !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>range, 'range');
    }
    if (dateFrom !== undefined && dateFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateFrom, 'dateFrom');
    }
    if (dateTo !== undefined && dateTo !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateTo, 'dateTo');
    }
    if (userId !== undefined && userId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>userId, 'userId');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/ai-gateway/analytics/quick-stats`;
    return this.httpClient.request<AnalyticsEnvelope>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Get analytics quick stats
   * Returns request count, spend, model count, token count, cache hit rate, and active key count for a range. Params: range and userId, which is accepted but ignored -- results are always scoped to the calling user, admins included.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public quickStatsShortAliasAnalyticsQuickStatsGet(
    requestParameters?: QuickStatsShortAliasAnalyticsQuickStatsGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<AnalyticsEnvelope>;
  public quickStatsShortAliasAnalyticsQuickStatsGet(
    requestParameters?: QuickStatsShortAliasAnalyticsQuickStatsGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<AnalyticsEnvelope>>;
  public quickStatsShortAliasAnalyticsQuickStatsGet(
    requestParameters?: QuickStatsShortAliasAnalyticsQuickStatsGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<AnalyticsEnvelope>>;
  public quickStatsShortAliasAnalyticsQuickStatsGet(
    requestParameters?: QuickStatsShortAliasAnalyticsQuickStatsGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const range = requestParameters?.range;
    const dateFrom = requestParameters?.dateFrom;
    const dateTo = requestParameters?.dateTo;
    const userId = requestParameters?.userId;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (range !== undefined && range !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>range, 'range');
    }
    if (dateFrom !== undefined && dateFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateFrom, 'dateFrom');
    }
    if (dateTo !== undefined && dateTo !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateTo, 'dateTo');
    }
    if (userId !== undefined && userId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>userId, 'userId');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/analytics/quick-stats`;
    return this.httpClient.request<AnalyticsEnvelope>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Get top API keys
   * Returns top API keys by spend or request count. Params: metric, range, limit, and userId, which is accepted but ignored -- results are always scoped to the calling user, admins included.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @deprecated
   */
  public topKeysApiAiGatewayAnalyticsTopKeysGet(
    requestParameters?: TopKeysApiAiGatewayAnalyticsTopKeysGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<AnalyticsEnvelope>;
  public topKeysApiAiGatewayAnalyticsTopKeysGet(
    requestParameters?: TopKeysApiAiGatewayAnalyticsTopKeysGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<AnalyticsEnvelope>>;
  public topKeysApiAiGatewayAnalyticsTopKeysGet(
    requestParameters?: TopKeysApiAiGatewayAnalyticsTopKeysGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<AnalyticsEnvelope>>;
  public topKeysApiAiGatewayAnalyticsTopKeysGet(
    requestParameters?: TopKeysApiAiGatewayAnalyticsTopKeysGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const metric = requestParameters?.metric;
    const range = requestParameters?.range;
    const dateFrom = requestParameters?.dateFrom;
    const dateTo = requestParameters?.dateTo;
    const limit = requestParameters?.limit;
    const userId = requestParameters?.userId;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (metric !== undefined && metric !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>metric, 'metric');
    }
    if (range !== undefined && range !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>range, 'range');
    }
    if (dateFrom !== undefined && dateFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateFrom, 'dateFrom');
    }
    if (dateTo !== undefined && dateTo !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateTo, 'dateTo');
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }
    if (userId !== undefined && userId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>userId, 'userId');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/api/ai-gateway/analytics/top-keys`;
    return this.httpClient.request<AnalyticsEnvelope>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Get top API keys
   * Returns top API keys by spend or request count. Params: metric, range, limit, and userId, which is accepted but ignored -- results are always scoped to the calling user, admins included.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public topKeysShortAliasAnalyticsTopKeysGet(
    requestParameters?: TopKeysShortAliasAnalyticsTopKeysGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<AnalyticsEnvelope>;
  public topKeysShortAliasAnalyticsTopKeysGet(
    requestParameters?: TopKeysShortAliasAnalyticsTopKeysGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<AnalyticsEnvelope>>;
  public topKeysShortAliasAnalyticsTopKeysGet(
    requestParameters?: TopKeysShortAliasAnalyticsTopKeysGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<AnalyticsEnvelope>>;
  public topKeysShortAliasAnalyticsTopKeysGet(
    requestParameters?: TopKeysShortAliasAnalyticsTopKeysGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const metric = requestParameters?.metric;
    const range = requestParameters?.range;
    const dateFrom = requestParameters?.dateFrom;
    const dateTo = requestParameters?.dateTo;
    const limit = requestParameters?.limit;
    const userId = requestParameters?.userId;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (metric !== undefined && metric !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>metric, 'metric');
    }
    if (range !== undefined && range !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>range, 'range');
    }
    if (dateFrom !== undefined && dateFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateFrom, 'dateFrom');
    }
    if (dateTo !== undefined && dateTo !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dateTo, 'dateTo');
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }
    if (userId !== undefined && userId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>userId, 'userId');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/analytics/top-keys`;
    return this.httpClient.request<AnalyticsEnvelope>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }
}
